import isNotProduction from "is-not-production"

/* eslint-disable */
export default isNotProduction ? console.error : Function.prototype
